import { render, staticRenderFns } from "./vehicleUpdatedToday.vue?vue&type=template&id=4c754232"
import script from "./vehicleUpdatedToday.vue?vue&type=script&lang=js"
export * from "./vehicleUpdatedToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports